import { useMemo } from 'react'
import { getTokenPayload } from '@/lib/auth'
import { ROLE_PRESETS, type Permission } from '@/lib/permissions'

export interface PermissionsApi {
  permissions: readonly Permission[]
  has: (permission: Permission) => boolean
  hasAny: (...permissions: Permission[]) => boolean
  hasAll: (...permissions: Permission[]) => boolean
}

export function usePermissions(): PermissionsApi {
  return useMemo(() => {
    const payload = getTokenPayload()

    // Fonte da verdade: payload.permissions (Fatia 3+). Para tokens antigos
    // que ainda não trazem o campo, derivamos do enum role via ROLE_PRESETS.
    const granted: readonly string[] = (() => {
      if (payload?.permissions) return payload.permissions
      if (payload?.role) return ROLE_PRESETS[payload.role]
      return []
    })()

    const grantedSet = new Set(granted)
    const has = (permission: Permission) => grantedSet.has(permission)

    return {
      permissions: granted as readonly Permission[],
      has,
      hasAny: (...perms) => perms.some(has),
      hasAll: (...perms) => perms.every(has),
    }
    // payload é lido do localStorage; é estável por render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
